<template>
	<div class="card md-elevation-4" style="background-color: #000066; color: white">
		<div style="display: flex; width: 100%">
			<div style="margin-top: auto; margin-bottom: auto">
				<md-progress-spinner
					v-if="tickets.active === undefined"
					md-mode="indeterminate"
					:md-diameter="30"
					:md-stroke="3"
					class="md-accent"
				/>
				<md-icon v-else class="md-size-2x" style="color: white">confirmation_number</md-icon>
			</div>
			<div style="margin-left: auto; margin-right: 0px; margin-top: auto; margin-bottom: auto">
				<strong style="font-size: 32px">{{ tickets.active }}</strong>
			</div>
			<br />
		</div>
		<span style="float: right">{{ $t("open-tickets") }} (+{{ tickets.today }} {{ $t("new-ticket-today") }})</span>
	</div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: "tickets-card",
	data() {
		return {}
	},

	computed: {
		...mapGetters({
			tickets: "dashboard/ticketsNumber"
		})
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/chart.scss";
</style>
